import React, {Component} from 'react';
import {List} from 'antd';
import {TIRE_REPLACEMENT, TIRES_EXCHANGE} from '../../definition/business';
import {tireExchangeDisplayText, tireReplacementDisplayText,} from '../../../helper/displayTextHelper';
import SAInfoBubble from "../../../../components/common/confirmation/SAInfoBubble";
import {durationToString} from "../../../../services/DurationUtil";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import PriceTag from '../../../../components/common/pricetag/PriceTag';

class N_ServicesSectionFragment extends Component {

  render() {
    const {
      intl:{formatMessage},
      selectedOptions,
      tireReplacement,
      tiresExchange,
      cart
    } = this.props;

    const mergedServices = [];
    if (selectedOptions) {
      Array.prototype.push.apply(mergedServices, selectedOptions);
    }
    if (cart) {
      Array.prototype.push.apply(mergedServices, cart.items.map(i => ({
        id: i.referenceId,
        title: i.name,
        price: i.price,
        duration: `PT${i.duration}M`
      })));
    }

    return (
      <List
        itemLayout="horizontal"
        dataSource={mergedServices}
        renderItem={item => {
          let specialDescription;
          if (item.id === TIRE_REPLACEMENT || item.name === TIRE_REPLACEMENT) {
            specialDescription = tireReplacementDisplayText(formatMessage, tireReplacement);
          } else if (item.id === TIRES_EXCHANGE || item.name === TIRES_EXCHANGE) {
            specialDescription = tireExchangeDisplayText(formatMessage, tiresExchange.type, tiresExchange.mode);
          }
          const description = `${item.description ? `${item.description}. ` : ''}${specialDescription || ''}`;
          return (
            <List.Item>
              <List.Item.Meta
                title={<span>{item.title}</span>}
                description={description}
              />
              <div>
                <PriceTag price={item.price}/>&nbsp;
                {item.duration ? `${durationToString(item.duration)}` : ''}{' '}
                {item.moreInfo && (
                  <SAInfoBubble content={item.moreInfo}/>
                )}
              </div>
            </List.Item>
          );
        }}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => {

  const userData = state.userData.body;
  if (userData.appointment){
    return {
      tiresExchange: userData.appointment.journey && userData.appointment.journey.properties && userData.appointment.journey.properties.services && userData.appointment.journey.properties.services.tiresExchange,
      tireReplacement: userData.appointment.journey && userData.appointment.journey.properties && userData.appointment.journey.properties.services && userData.appointment.journey.properties.services.tiresReplacement,
      cart: userData.appointment.journey && userData.appointment.journey.properties && userData.appointment.journey.properties.services && userData.appointment.journey.properties.services.valueServicesCart,
      selectedOptions: userData.appointment.journey && userData.appointment.journey.properties && userData.appointment.journey.properties.services && userData.appointment.journey.properties.services.services,
    }
  } else {
    return {
      tiresExchange: state.createAppointmentRequest.tiresExchange,
      tireReplacement: state.createAppointmentRequest.tireReplacement,
      cart: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.cart,
      selectedOptions: state.createAppointmentRequest.selectedOptions
    }
  }

};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(N_ServicesSectionFragment)
);




// WEBPACK FOOTER //
// ./src/public/journey1/fragments/sectionFragment/N_ServicesSectionFragment.js